<template>
	<type-wrapper class="type-G" regular :bgImage="showData.image" :bgColor="showData.bg_color">
		<type-grid row="12" margin>
			<type-text type="title" size="1" align="left" v-if="showData.title">{{ showData.title }}</type-text>
			<type-text type="content" size="9" v-if="showData.content">{{ showData.content }}</type-text>
		</type-grid>
		<type-grid row="12" margin>
			<div class="type-G-leave-email">
				<input class="email-value text-content-6" type="text" placeholder="Leave email" v-model="email">
				<type-button class="email-button" round size="9" height="40px" @click="sendEmail">SEND</type-button>
			</div>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 简版收email地址框
	import mixin from '../mixin.js'
	export default {
		name: 'type-G',
		mixins: [ mixin ],
		data() {
			return {
				email: ''
			}
		},
		methods: {
			sendEmail() {
				const data = {
					email: this.email
				};
				const result = this.$verify.verify(data);
				// console.log('数据', JSON.parse(JSON.stringify(data)), '验证', JSON.parse(JSON.stringify(result)))
				if (result.error.email) {
					this.$message(result.error.email);
				} else {
					const content = `email=${data.email}`;
					this.$http.user.report_bug(content).then(res => {
						if (res.status === 'success') {
							this.$message('Submitted');
							this.email = '';
						}
					});
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.type-G{
        .type-G-leave-email{
        	width: 100%;
        	height: 60px;
        	display: flex;
            overflow: hidden;
        	align-items: center;
        	border-radius: 30px;
			padding: 0 10px 0 20px;
			width: calc(100% - 30px);
        	background-color: #FFFFFF;
        	justify-content: space-between;
        	box-shadow: inset 0 1px 1px rgba(0, 0, 0,  .075), 0 0 8px rgba(102, 175, 233, .6);
        	.email-value{
        		height: 40px;
        		border: none;
        		outline: none;
        		color: #000000;
        		font-weight: 300;
        		line-height: 40px;
        		width: calc(100% - 110px);
        		&:focus{
        			border: none;
        			outline: none;
        		}
        		&:-webkit-input-placeholder, &::-webkit-input-placeholder, &:-ms-input-placeholder, &::-ms-input-placeholder, &:-moz-placeholder, &::-moz-placeholder{
        			color: #FAFAFA;
        		}
        	}
        	.email-button{
        		background-color: #41466E;
        	}
        }
    }
</style>
